import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/app/AuthContext";
import WordmarkLogo from "@/components/wynn/WordmarkLogo";
import Home from "@/app/screens/Home";
import Practices from "@/app/screens/Practices";
import Journal from "@/app/screens/Journal";
import { House, Wind, NotebookPen, LogOut } from "lucide-react";

const TABS = [
  { key: "home", label: "Home", icon: House, Component: Home },
  { key: "practices", label: "Practices", icon: Wind, Component: Practices },
  { key: "journal", label: "Journal", icon: NotebookPen, Component: Journal },
];

export default function AppShell() {
  const { user, logout } = useAuth();
  const [active, setActive] = useState("home");
  const ActiveScreen = TABS.find((t) => t.key === active).Component;

  return (
    <div className="min-h-screen bg-[#070608] text-[#F4F1EC] flex flex-col">
      {/* Top bar */}
      <header className="sticky top-0 z-40 bg-[#070608]/85 backdrop-blur-xl border-b border-[#F4F1EC]/10">
        <div className="max-w-[1000px] mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <WordmarkLogo height={18} />
            <span className="text-[9px] uppercase tracking-[0.22em] font-body text-[#FFB7C6] border border-[#FFB7C6]/40 px-2 py-0.5">
              Preview
            </span>
          </Link>
          <div className="flex items-center gap-4">
            <span className="hidden sm:block font-body text-xs text-[#F4F1EC]/50">
              {user?.name ? `Hello, ${user.name}` : user?.email}
            </span>
            <button
              data-testid="app-logout"
              onClick={logout}
              className="text-[#F4F1EC]/55 hover:text-[#FFB7C6] transition-colors"
              aria-label="Sign out"
            >
              <LogOut size={18} strokeWidth={1.6} />
            </button>
          </div>
        </div>
      </header>

      {/* Screen */}
      <main className="flex-1 max-w-[1000px] w-full mx-auto px-5 md:px-8 py-8 md:py-12 pb-28">
        <ActiveScreen onNavigate={setActive} />
      </main>

      {/* Bottom tab bar */}
      <nav className="fixed bottom-0 left-0 right-0 z-40 bg-[#0A0910]/90 backdrop-blur-xl border-t border-[#F4F1EC]/10">
        <div className="max-w-[1000px] mx-auto px-4 grid grid-cols-3">
          {TABS.map((t) => {
            const Icon = t.icon;
            const on = active === t.key;
            return (
              <button
                key={t.key}
                data-testid={`tab-${t.key}`}
                onClick={() => setActive(t.key)}
                className={`flex flex-col items-center gap-1 py-3 transition-colors ${
                  on ? "text-[#FFB7C6]" : "text-[#F4F1EC]/50 hover:text-[#F4F1EC]/80"
                }`}
              >
                <Icon size={20} strokeWidth={1.5} />
                <span className="text-[10px] uppercase tracking-[0.14em] font-body">{t.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
